import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import {
  LocationStrategy,
  HashLocationStrategy,
  APP_BASE_HREF,
} from "@angular/common";
import { routing } from "./components/app-routing.module";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";

import { EJAngular2Module } from "ej-angular2";

import { ModalModule } from "./allgemeinesTS_CSS/_modal";

import { AppComponent } from "./components/app.component";
import { LoginComponent } from "./components/login/login.component";
import { CraneSelectionComponent } from "./components/craneSelection/craneSelection.component";
import { ControlAllgemeinComponent } from "./components/craneControlAllgemein/controlAllgemein.component";
import { ControlMaxBaseComponent } from "./components/craneControlMaxBase/controlMaxBase.component";
import { Control360Component } from "./components/craneControl360/control360.component";
import { Tabellen360GradSetupComponent } from "./components/craneSetup/tabellen30GradSetup.component";
import { KranSetupAllgemeinComponent } from "./components/craneSetup/kranSetupAllgemein.component";
import { HeaderComponent } from "./components/header/header.component";
import { MenueComponent } from "./components/menue/menue.component";
import { Error404Component } from "./components/404/error404.component";
import { MaxBaseComponent } from "./components/craneSetup/maxBase.component";
import { ImageAngleFromCenterComponent } from "./components/ImageAngleFromCenter/ImageAngleFromCenter.component";
import { CapacityChartComponent } from "./components/craneControlMaxBase/capacityChart.component";
// import {CranePrintOutComponent} from './components/cranePrintOut/cranePrintOut.component';
import { IOSLinkDocumentationComponent } from "./components/LinkDocumentations/IOSLinkDocumentation/IOSLinkDocumentation.component";

import { FehlermeldungComponent } from "./components/Fehlermeldung/Fehlermeldung.component";

// import { CommonModule } from "@angular/common";

@NgModule({
  imports: [
    BrowserModule,
    routing,
    ReactiveFormsModule,
    HttpClientModule,
    EJAngular2Module.forRoot(),
    ModalModule,
    // CommonModule,
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    CraneSelectionComponent,
    HeaderComponent,
    MenueComponent,
    Error404Component,
    MaxBaseComponent,
    KranSetupAllgemeinComponent,
    Tabellen360GradSetupComponent,
    ControlMaxBaseComponent,
    Control360Component,
    ControlAllgemeinComponent,
    ImageAngleFromCenterComponent,
    CapacityChartComponent,
    //    CranePrintOutComponent,
    IOSLinkDocumentationComponent,
    FehlermeldungComponent,
    ImageAngleFromCenterComponent,
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  // providers:[{provide: APP_BASE_HREF, useValue: '/'}], // requires configuring redirects on web server
  bootstrap: [AppComponent],
})
export class AppModule {}
